import React, { useState } from 'react';
import { motion } from 'framer-motion';
import './FAQ.css';

const faqItems = [
  {
    question: 'How do I book a driver?',
    answer:
      'Select your service, choose your preferred date and time, and confirm your booking in just a few taps.',
  },
  {
    question: 'Can I schedule a booking?',
    answer:
      'Yes! Book instantly or schedule your ride for any future date and time.',
  },
  {
    question: 'Are drivers verified?',
    answer:
      'Every driver completes identity verification, document validation, and background checks before joining iDRIVEA.',
  },
  {
    question: 'How are payments made?',
    answer:
      'Pay securely using UPI, Debit/Credit Cards, Net Banking, Wallets, or Cash.',
  },
  {
    question: 'What if I cancel?',
    answer:
      'Enjoy free cancellation within the allowed cancellation window. Terms and conditions apply.',
  },
  {
    question: 'Is customer support available?',
    answer:
      'Absolutely! Our customer support team is available 24×7 through chat, phone, and email.',
  },
];

export default function FAQ() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="faq-section simple">
      <div className="faq-header-simple">
        <span className="faq-badge">Frequently Asked Questions</span>
      </div>

      <div className="faq-cards simple">
        {faqItems.map((item, index) => (
          <motion.div
            key={item.question}
            className={`faq-card ${open === index ? 'open' : ''}`}
            onClick={() => setOpen(open === index ? null : index)}
            aria-expanded={open === index}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.45, delay: index * 0.06 }}
          >
            <button type="button" className="faq-card-top">
              <div className="faq-question">{item.question}</div>
              <div className="faq-toggle">{open === index ? '−' : '+'}</div>
            </button>
            <div className="faq-answer">
              <p>{item.answer}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
